<template>
  <div v-show="showFeedback" class="ca-u-margin-top">
    <ca-form
      :on-submit="sendFeedback"
      :error-message="errorMessage"
      :on-submit-error="onSubmitError"
      :on-submit-success="onSubmitSuccess">
      <ds-feedback
        v-model="feedback"
        class="ca-u-margin-bottom"
        first-rate-text="Muito difícil"
        last-rate-text="Muito fácil"
        label="Conte-nos mais sobre o que está achando"
        title="Como está sendo a sua experiência de cadastrar um funcionário até agora?" />
      <ca-row>
        <ca-col>
          <ca-submit-button
            theme="secondary">
            Enviar opinião
          </ca-submit-button>
        </ca-col>
      </ca-row>
    </ca-form>
  </div>
</template>
<script>
import { toasterService } from 'packages/common/ds-components';
import { clickSubmitNewWorkerFeedback } from '../workerTrackerService';

export default {
  name: 'WorkerFeedback',
  data() {
    return {
      feedback: null,
      errorMessage: null,
      feedbackAvailable: true,
    };
  },
  computed: {
    showFeedback() {
      return this.feedbackAvailable;
    },
  },
  methods: {
    sendFeedback() {
      return clickSubmitNewWorkerFeedback(this.feedback);
    },
    onSubmitError() {
      this.errorMessage = {
        title: 'Ocorreu um erro ao enviar seu feedback',
        description: 'Aguarde alguns instantes e tente novamente.',
      };
    },
    onSubmitSuccess() {
      toasterService.success({
        content: 'Agradecemos pela avaliação',
      });

      this.feedbackAvailable = false;
    },
  },
};
</script>
